import { Http } from "../Http";
import { AxiosPromise } from "axios";
import { getUserAccessToken } from "../selectors/Accounts";

export default class MusicsService {
	public static musicsSave(input: any) {
		return input?.id > 0
			? Http.axios()
					.put(`/api/MusicAlbum/update`, input?.musicsInput, {
						headers: { Authorization: getUserAccessToken() },
					})
					.then((res: any) => {
						return res;
					})
					.catch((e: any) => {
						return e.response;
					})
			: Http.axios()
					.post("/api/MusicAlbum/add", input?.musicsInput, {
						headers: { Authorization: getUserAccessToken() },
					})
					.then((res: any) => {
						return res;
					})
					.catch((e: any) => {
						return e.response;
					});
	}

	public static musicsGetByFilter(input: any) {
		return Http.axios()
			.post(`/api/MusicAlbum/GetAllMusicAlbums`, input, {
				headers: { Authorization: getUserAccessToken() },
			})
			.catch((e: { response: any }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static musicsGetDetail(id: any) {
		return Http.axios()
			.get("/api/MusicAlbum/" + id, {
				headers: { Authorization: getUserAccessToken() },
			})
			.then((res: any) => {
				return res;
			})
			.catch((e: { response: any }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static musicsDelete(input: any) {
		return Http.axios()
			.delete("/api/MusicAlbum/delete/" + input, {
				headers: { Authorization: getUserAccessToken() },
			})
			.catch((e: { response: any }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static musicsVideoStatusUpdate(input: any) {
		return Http.axios()
			.post("/api/MusicAlbum/update-music-album-active", input, {
				headers: { Authorization: getUserAccessToken() },
			})
			.then((res: any) => {
				return res;
			})
			.catch((e: any) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static musicPlatformList() {
		return Http.axios()
			.get("/api/StreamingPlatform/dropdown-list", {
				headers: { Authorization: getUserAccessToken() },
			})
			.then((res) => res.data)
			.catch((e) => {
				return (
					e.response?.data || {
						success: false,
						message: "Something went wrong",
					}
				);
			});
	}
}
